import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import { Nav } from "../../components/nav";
import { useGetAssociation } from "../../queries/get-association";
import { useGetAssociationContext } from "../../queries/get-association-context";
import { useLocale } from "../../stores/locale";
import { getId } from "../../utils/id";
import { IssueBoard } from "./issue-board";
import { IssueFastumList } from "./issue-fastum-list";
import { IssueList } from "./issue-list";

export function Issues() {
  const { locale: t } = useLocale();
  const { data: associationContext } = useGetAssociationContext();
  const { data: association } = useGetAssociation(
    getId(associationContext?.id ?? ""),
  );
  const hasFastumIntegration = Boolean(association?.integrations?.fastum);

  return (
    <>
      <Nav
        className="mb-4"
        items={[
          { title: t.issue.issues, slug: "/admin/issue/list" },
          { title: t.issue.board, slug: "/admin/issue/board" },
          ...(hasFastumIntegration
            ? [{ title: t.issue.fastumTickets, slug: "/admin/issue/fastum" }]
            : []),
        ]}
      />
      <Routes>
        <Route index element={<Navigate replace to="list" />} />
        <Route element={<IssueList />} path="/list/*" />
        <Route element={<IssueBoard />} path="/board/*" />
        {hasFastumIntegration && (
          <Route element={<IssueFastumList />} path="/fastum" />
        )}
      </Routes>
      <Outlet />
    </>
  );
}
